import React from 'react';
import { Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import './Portfolio.css'
const Portfolio = ({ portfolio }) => {
    const { _id, name, img } = portfolio;
    // console.log(portfolio)
    const url = `/Portfolio/${_id}`
    return (
        <div>
            <div className="container">

                <Col className="portfolio-design">
                    <Card>
                        <Card.Img variant="top" src={img} />
                        <Card.Body>
                        </Card.Body>
                    </Card>
                    <NavLink to={url}>  <i class="fas fa-arrow-right">View details</i> </NavLink>
                    
                </Col>
            </div>
        </div>
    );
};

export default Portfolio;